
import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import BlueButton from '../Atomic/BlueButton.vue'
import GreenButton from '../Atomic/GreenButton.vue'
import RedButton from '../Atomic/RedButton.vue'

// Used for notifications.
import ErrorHandler from '@/services/ErrorHandlerService'
import { INotificationService } from '@/services/NotificationService'
import UserMIREO from '../../models/userMireo'
import UserMireoService from '@/services/UserMireoService'
import CardTitle from '@/components/Atomic/CardTitle.vue'
import ProgressLinear from '@/components/Atomic/ProgressLinear.vue'

@Component({
  components: {
    ProgressLinear,
    BlueButton,
    GreenButton,
    RedButton,
    CardTitle,
  },
})
export default class EndMission extends Vue {
  @Prop(Function) public readonly onClose!: () => void
  private isPending: boolean = false
  private endDialog: boolean = false
  private errorHandler = new ErrorHandler()
  private $notificationService!: INotificationService
  private account: any = {}

  constructor() {
    super()
  }

  public show(account: UserMIREO) {
    this.endDialog = true
    this.account = account
  }

  private cancel() {
    this.endDialog = false
  }

  private async end() {
    this.isPending = true
    try {
      const response = await UserMireoService.endMission(
        this.account.ad_personne_id,
        this.account.identifiant,
        this.account.etablissement_id,
      )
      this.$notificationService.success(
        this.$t('MIREOACCOUNT.EndSuccessMessage').toString(),
      )
    } catch (error: any) {
      this.errorHandler.handle(this, error.response.data.code, true)
    } finally {
      this.isPending = false
      this.account = {}
      this.endDialog = false
      this.onClose()
    }
  }
}
